import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { TokenService } from '../../services/token.service';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  public form = {
    email: null,
    name: null,
    password: null,
    password_confirmation: null
  };
  public error: any = [];

  constructor(private User: UserService, private Token: TokenService, private router: Router, private notify: SnotifyService) { }

  onSubmit() {
    this.User.signup(this.form).subscribe(
      data => this.handleResponse(data),
      error => this.handleError(error)
    );
  }

  handleResponse(data) {
    this.notify.success('Usuário cadastrado com sucesso.', {timeout: 2000, showProgressBar: false });
    this.router.navigateByUrl('/usuarios');
  }

  handleError(error) {
    this.error = error.error.errors;
    this.notify.error(this.error, {timeout: 3000, showProgressBar: false });
  }

  ngOnInit() {
  }

}
